export enum IssueGroupBy {
  HASH = 'hash',
  COMPONENT_HASH = 'componentHash',
  CUSTOM_HASH = 'customHash',
  END_USER_HASH = 'endUserHash',
  SESSION_ID = 'sessionId',
  TITLE_HASH = 'titleHash',
}
